<template>
  <div class="newstopic sort_form">
    <div class="sort_form_list">
      <el-select v-model="sortFormvalue"
                 placeholder="请选择串联单"
                 @change='getCurrentSortFormInfo'>
        <el-option v-for="item in sortFormInfoData"
                   :key="item.id"
                   :label="item.title"
                   :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-scrollbar class="comments sort_form_el">
      <div class="news_topic">
        <div class="news_topic_title">
          <span>创建时间</span>
          <span v-if='currentSortFormObj.createDate'>{{currentSortFormObj.createDate | timeSubstring}}</span>
          <span style="margin-left:36px;">使用日期</span>
          <span v-if='currentSortFormObj.useDate'>{{currentSortFormObj.useDate | timeSubstring}}</span>
        </div>
      </div>
      <div class="news_topic_content">
        <div class="news_topic_person">
          <div class="news_topic_person_left">
            <span class="iconfont icon-renwu"></span>
            <span class="person_title">创建人</span>
          </div>
          <div class="news_topic_person_right">
            <div class="news_topic_person_each">
              <div class="news_topic_person_avator">
                <img :src="currentSortFormObj.creatUserHeadImg"
                     alt=""
                     v-if='currentSortFormObj && currentSortFormObj.creatUserHeadImg'>
                <img src="../../../static/img/avatar.png"
                     alt=""
                     v-if='currentSortFormObj && !currentSortFormObj.creatUserHeadImg'>
              </div>
              <div class="news_topic_person_name">{{currentSortFormObj.createUserName}}</div>
            </div>
          </div>
        </div>
        <div class="news_topic_person">
          <div class="news_topic_person_left">
            <span class="iconfont icon-renwu"></span>
            <span class="person_title">关联人员</span>
          </div>
          <div class="news_topic_person_right">
            <div class="news_topic_person_each"
                 v-for="item in currentSortFormObj.userList">
              <el-popover placement="top-start"
                          width="200"
                          trigger="hover"
                          popper-class='popover_class'>

                <ul v-if='item.jobs.hasOwnProperty("length") && item.jobs.length > 0'>
                  <li v-for='job in item.jobs'>{{job.jobName}}</li>
                </ul>
                <div v-if='!item.jobs || (item.jobs.hasOwnProperty("length") && item.jobs.length == 0)'>无</div>
                <div class="news_topic_person_avator"
                     slot="reference"
                     style="cursor:pointer;">
                  <img :src="item.headimg"
                       alt=""
                       v-if='item.headimg'>
                  <img src="../../../static/img/avatar.png"
                       alt=""
                       v-if='!item.headimg'>
                </div>
              </el-popover>
              <div class="news_topic_person_name">{{item.username}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="interview">
        <span class="interview_title">串联单类型</span>
        <input type="text"
               v-if='currentSortFormObj && currentSortFormObj.contactType'
               v-model="currentSortFormObj.contactType.typeName"
               readonly>
      </div>
      <div class="interview">
        <span class="interview_title">备注</span>
        <input type="text"
               readonly
               style="margin-left:20px;"
               v-if='currentSortFormObj'
               :title="currentSortFormObj.remarks"
               v-model="currentSortFormObj.remarks">
      </div>

      <div class="interview"
           style="border:0;">
        <span class="interview_title">关联稿件</span>
      </div>
      <div class="news_topic_artilcelist">
        <div class="news_topic_article_each"
             v-for='(item,index) in currentSortFormObj.manuscriptList'>
          <div class="news_sortform_index">{{index+1}}</div>
          <div class="news_topic_artilce_title"
               style="width:390px;"
               :title="item.manuscriptTitle"
               :class="[item.id === articleId ? 'current_article_active':'']">{{item.manuscriptTitle}}</div>
        </div>
      </div>

    </el-scrollbar>
  </div>
</template>

<script>
import { getUrlCode } from '../../../utils/index.js'
import * as api from '../../../api'
export default {
  name: 'sortform',
  data() {
    return {
      sortFormvalue: '',
      currentSortFormObj: ''
    }
  },
  created() {

  },
  components: {

  },
  computed: {
    sortFormInfoData() {
      return this.$store.state.logs.sortFormInfo
    },
    articleId() {
      return this.$parent.$parent.articleId
    }
  },
  mounted() {


  },
  destroyed() {

  },
  methods: {
    getCurrentSortFormInfo(id) {
      if (this.sortFormInfoData.length > 0) {
        for (var i = 0; i < this.sortFormInfoData.length; i++) {
          if (this.sortFormInfoData[i].id === id) {
            this.currentSortFormObj = this.sortFormInfoData[i]
            break;
          }
        }
      }
    }

  },
  watch: {
    sortFormInfoData() {
      if (this.sortFormInfoData && this.sortFormInfoData.hasOwnProperty('length') && this.sortFormInfoData.length > 0) {
        this.currentSortFormObj = this.sortFormInfoData[0]
        this.sortFormvalue = this.sortFormInfoData[0].id
      } else {
        this.currentSortFormObj = ''
        this.sortFormvalue = ''
      }

    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/newstopic.styl'

.sort_form
  position relative

  .current_article_active
    color #1989fa !important

  .sort_form_list
    box-sizing border-box
    padding 10px
    border-bottom 1px solid #cccccc

  .sort_form_el
    height 90%

    .news_topic_content
      border-top none
</style>
